/**
 * Shared VSB Farm Canonical Workflow Status Engine
 * Canonical Lifecycle: Active -> Draft -> Finalized -> Closed
 *
 * Governing Invariants:
 * - Active: cycle open with no active draft settlement
 * - Draft: cycle open with an active draft settlement
 * - Finalized: settlement finalized/locked
 * - Closed: production cycle closed
 */

export type WorkflowStatus = 'active' | 'draft' | 'finalized' | 'closed';

export interface WorkflowContext {
  cycleStatus?: string | null;
  settlement?: {
    status?: string | null;
    is_void?: boolean | null;
    isFrozen?: boolean | null;
  } | null;
}

export function deriveWorkflowStatus(context: WorkflowContext): WorkflowStatus {
  if (context.cycleStatus === 'closed') {
    return 'closed';
  }

  const s = context.settlement;
  if (s && !s.is_void) {
    if (
      s.status === 'frozen' ||
      s.status === 'finalized' ||
      s.isFrozen ||
      context.cycleStatus === 'settled'
    ) {
      return 'finalized';
    }
    return 'draft';
  }

  if (context.cycleStatus === 'settled' || context.cycleStatus === 'finalized') {
    return 'finalized';
  }

  return 'active';
}
